
// src/web/components/kpi-preview.jsx

import React from 'react'
import { themr } from 'react-css-themr'
import KpiPreviewTheme from './themes/kpi-preview.css'
import classnames from 'classnames'
import { percent } from '../../helpers/format-number'

function Row(props) {
  const {
    t,
    theme,
    label,
    value,
    isPercent,
    format,
    unit,
    formatLabel,
    prependUnit
  } = props
  const renderUnit = () => {
    if(unit){
      return (
        <span>
          {prependUnit && <span className={theme.unit}>{unit}</span>}
          <span className={theme.number}>
             {` ${formatLabel} `} 
          </span>
          {!prependUnit && <span className={theme.unit}>{unit}</span>}
        </span>)
    } else {
      return (
        <span>
          {prependUnit && <span className={theme.unitError}>__</span>}
          <span className={theme.number}>
             {` ${formatLabel} `} 
          </span>
          {!prependUnit && <span className={theme.unitError}>__</span>}
        </span>)
    }
  }
  return (
    <div className={theme.row}>
      <div className={theme.label}>{label}</div>
      <div className={theme.value}>
        {!isPercent && renderUnit()}
        {isPercent &&
          <span className={theme.achieved}>{t('label:達成')}</span>}
        {isPercent && 
          <span>
            <span className={theme.number}>{percent(1)}</span>
            <span className={theme.unit}>%</span>
          </span>}
      </div>
    </div>
  )
}

@themr('KPIPreview', KpiPreviewTheme)
class KPIPreview extends React.Component {
  render() {
    const {
      t,
      theme,
      kpi,
      group,
      ui,
      formatLabel,
    } = this.props

    return (
      <div className={classnames(theme.kpi)}>
        <div className={theme.desc}>
          {t('label:プレビュー説明')}
        </div>
        <h3 className={ui.name?theme.title:theme.titleError} >
          {ui.name && ui.name || `↑ ${t('error:KPI名を入力してください')} `}
        </h3>
        <h3 className={ui.unit?theme.title:theme.titleError} >
          {!ui.unit && `↑ ${t('error:単位を入力してください')} `}
        </h3>
        <div className={theme.rows}>
          <Row theme={theme} label={t('label:目標')} value={ui.target} formatLabel={formatLabel} unit={ui.unit} prependUnit={ui.prependUnit}/>
          <Row theme={theme} label={t('label:実績')} value={ui.actual} formatLabel={formatLabel} unit={ui.unit} prependUnit={ui.prependUnit}/>
          {ui.accumulatedTotal && <Row theme={theme} label={t('label:累計')} value={ui.total} formatLabel={formatLabel} unit={ui.unit} prependUnit={ui.prependUnit}/>}
          <Row t={t} theme={theme} label={t('label:達成率')} value={(ui.total || ui.actual) / ui.target} isPercent prependUnit={ui.prependUnit}/>
        </div>
      </div>
    )
  }
}

export default KPIPreview



// WEBPACK FOOTER //
// ./src/web/components/kpi-preview.jsx